const keywordService = {
    parseKeyword: (response) => {
        if (response.allUppercase) {
            return response.keyword.toUpperCase();
        }
        return response.keyword;
    },
};

export default keywordService;
